import { CrashService } from './services/crash.service';
import { ConfigService } from './services/config.service';
import { LoaderService } from './services/loader.service';
import { User, AuthService } from './services/auth.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { IapService } from './services/iap.service';
import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateService } from '@ngx-translate/core';
import { PushService } from './services/push.service';
import firebase from 'firebase/app';
import 'firebase/firestore';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  userDataSubscription: Subscription;
  userData: User;
  path: string;
  public selectedIndex = 0;
  public appPages = [
    {
      id: 'menu-command-notifications',
      title: 'Notifications',
      clicked: () => {
        this.router.navigate(['/notifications']);
      },
      icon: 'home',
      hidden: false,
    },
    {
      id: 'menu-command-messages',
      title: 'Messages',
      clicked: () => {
        this.router.navigate([`/messages/${this.userData.currentTeamId}/list`]);
      },
      icon: 'send',
      hidden: false,
    },
    {
      id: 'menu-command-direct-messages',
      title: 'Direct Messages',
      clicked: () => {
        this.router.navigate([`/inbox/${this.userData.currentTeamId}`]);
      },
      icon: 'chatbubbles',
      hidden: false,
    },
    {
      id: 'menu-command-members',
      title: 'Members',
      clicked: () => {
        this.router.navigate([`/members/${this.userData.currentTeamId}/list`]);
      },
      icon: 'people',
      hidden: false,
    },
    {
      id: 'menu-command-administrators',
      title: 'Administrators',
      clicked: () => {
        this.router.navigate([`/staff/${this.userData.currentTeamId}/list`]);
      },
      icon: 'people-circle',
      hidden: false,
    },
    {
      id: 'menu-command-teams',
      title: 'Teams',
      clicked: () => {
        this.router.navigate(['/teams']);
      },
      icon: 'home',
      hidden: false,
    },
    {
      id: 'menu-command-settings',
      title: 'Settings',
      clicked: () => {
        this.router.navigate(['/settings']);
      },
      icon: 'settings',
      hidden: false,
    },
    {
      id: 'menu-command-account',
      title: 'Account',
      clicked: () => {
        this.router.navigate(['/account']);
      },
      icon: 'person-circle',
      hidden: false,
    },
  ];
  // showSplash = true;

  constructor(
    private plt: Platform,
    private iap: IapService,
    private translate: TranslateService,
    public auth: AuthService,
    private router: Router,
    private ionLoader: LoaderService,
    private push: PushService,
    public crash: CrashService
  ) {
    this.ionLoader.showLoader('app component');
    this.translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    this.translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    this.initializeApp();
  }

  initializeApp() {
    console.log('initializeApp()');
    // this.crash.init();
    this.plt.ready().then((readySource) => {
      console.log('platform ready', readySource);
      if (this.iap.isMobileApp()) {
        console.log('mobile ready');
        this.crash.trapOnDevice();
        this.push.init();
        this.plt.resume.subscribe(async () => {
          console.log('Resume event detected');
          const token = await this.push.firebaseX.getToken();
          console.log('Resume got a token', token);
          if (this.userData.userPushToken !== token) {
            const changes: User = { userPushToken: token };
            await this.auth.updateUser(changes);
          }
        });
        // this.checkForUpdate();
        // this.statusBar.styleDefault();
        // this.statusBar.overlaysWebView(false);
        // this.statusBar.backgroundColorByName('black');
        // this.splashScreen.hide();
        this.iap.initializeStore();
      } else {
        console.log('desktop ready');
      }
    });
    this.ionLoader.hideLoader('app component');
  }

  ngOnInit() {
    this.userDataSubscription = this.auth.userData$.subscribe(
      async (userData) => {
        if (userData) {
          this.userData = userData;
          if (userData.currentTeamId) {
            this.menuActiveTeamToggle(false);
            console.log(`App says we know current team`, userData);
          } else {
            if (!userData.uid) {
              console.log(`App says we do NOT know the user yet`, userData);
            } else {
              console.log(`App says user has no current team`, userData);
              this.menuActiveTeamToggle(true);
            }
          }
        }
      },
      (error: any) => {
        this.crash.subscription('App Component', 'userDataSubscription', error);
      }
    );
  }

  menuSelected(menuItem, i) {
    this.selectedIndex = i;
    menuItem.clicked();
  }

  menuActiveTeamToggle(hidden) {
    this.appPages.forEach((page) => {
      if (
        page.title === 'Messages' ||
        page.title === 'Direct Messages' ||
        page.title === 'Members' ||
        page.title === 'Administrators'
      ) {
        page.hidden = hidden;
      }
    });
  }
}
